module.exports = __webpack_public_path__ + "img/gwyx-bdxfc.4e435018.png";